import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { PermissionService } from "../../../services/api/permission/permission.service";
import { LangSwitchComponent } from "../lang-switch/lang-switch.component";
import { NotificationsSettingsComponent } from "../notifications-settings/notifications-settings.component";
import { HasPermissionDirective } from "../../directives/has-permission/has-permission.directive";

@Component({
  selector: "app-profile-settings",
  imports: [LangSwitchComponent, NotificationsSettingsComponent, TranslateModule, HasPermissionDirective],
  templateUrl: "./profile-settings.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./profile-settings.component.scss",
})
export class ProfileSettingsComponent {
  private readonly dialogRef = inject(DynamicDialogRef);
  public readonly permissions = inject(PermissionService);

  protected close(): void {
    this.dialogRef.close();
  }
}
